import { render, staticRenderFns } from "./my-cv.vue?vue&type=template&id=359b9207&lang=html&"
import script from "./my-cv.vue?vue&type=script&lang=js&"
export * from "./my-cv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports